import "core-js/modules/es.array.concat";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Pagination from './Pagination.vue';
export default {
  components: {
    Pagination: Pagination
  },
  props: {
    data: {
      type: Array,
      default: function _default() {
        return null;
      }
    },

    /** 初始化页面时是否加重数据 */
    loadInit: {
      default: true
    },
    apiName: {
      default: '',
      type: String
    },
    headStyle: {
      type: Function,
      default: function _default() {
        return 'text-align:center;background-color:#F6F6F6';
      }
    },
    headStyle2: {
      type: Function,
      default: function _default() {
        return 'text-align:center';
      }
    },

    /** 请求时的配置 */
    request: {
      type: Object,
      default: function _default() {
        return {
          api: '',
          // 对应this.$api下的key
          params: {},

          /** 自定义返回数据的解析 */
          parser: function parser(res) {
            return {
              records: res.records,
              pageIndex: res.current,
              pageSize: res.size
            };
          }
        };
      }
    },

    /**
     * @description 分页配置
     * 默认显示，传入 false 隐藏分页器
     **/
    pagination: {
      type: Object | String,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // 表头居中显示
      // headClass () {
      //   return 'text-align:center'
      // },
      loading: false,
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0
    };
  },
  mounted: function mounted() {
    if (this.loadInit) {
      this.$refs.basePagination.onChange();
    }
  },
  methods: {
    /**
     * @description 提供外部使用的方法
     * @param {boolean} isReset 是否需要重置页码
     */
    loadData: function loadData() {
      var isReset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.$refs.basePagination.loadWithPageInfo(isReset);
    },
    callData: function callData(_ref) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var pageIndex, pageSize, _this$request, api, params, parser, withPageInfoParams, res, records, parseObj;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pageIndex = _ref.pageIndex, pageSize = _ref.pageSize;
                _this$request = _this.request, api = _this$request.api, params = _this$request.params, parser = _this$request.parser;

                if (api) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                withPageInfoParams = _objectSpread({
                  pageNo: pageIndex,
                  pageSize: pageSize
                }, params);
                _this.loading = true;
                _context.next = 8;
                return _this.$api[api](withPageInfoParams).catch(function () {
                  return null;
                });

              case 8:
                res = _context.sent;
                _this.loading = false;

                if (res) {
                  if (parser) {
                    parseObj = parser(res);
                    records = parseObj === null || parseObj === void 0 ? void 0 : parseObj.records;
                    _this.total = parseObj === null || parseObj === void 0 ? void 0 : parseObj.total;
                  } else {
                    records = res.records;
                    _this.total = res.total;
                  }

                  _this.tableData = records;
                }

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selectionChange: function selectionChange() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['selection-change'].concat(args));
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: function handler() {
        if (this.data) {
          this.tableData = this.data;
        }
      }
    }
  }
};